import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/**
 * Forwards the standalone worklist URL to the org workspace section (GDN-2774).
 *
 * The worklist shipped at `/organization/{id}/billing-worklist`, which left the
 * org workspace — the rail swapped to the global one and an org-scoped page
 * read as a global one. It's a section of the org detail page now, so the old
 * URL points at the section instead of 404ing.
 *
 * Existing filter/page links keep working: the query string carries over
 * untouched and only `tab` is added, so a bookmarked
 * `…/billing-worklist?stage=submit&page=3` lands on exactly those rows.
 */
export default function BillingWorklistRedirect() {
  const { organizationId } = useParams<{ organizationId: string }>();
  const [searchParams] = useSearchParams();

  if (!organizationId) return <Navigate to="/admin-v2" replace />;

  const next = new URLSearchParams(searchParams);
  next.set('tab', 'billing-worklist');

  return (
    <Navigate
      to={`/admin-v2/organization/${encodeURIComponent(organizationId)}?${next.toString()}`}
      replace
    />
  );
}
